<div class="h-12 w-full" [tuiSkeleton]="true"></div>
<div class="flex h-full max-h-[62vh] flex-col gap-2 p-4" data-testid="examinations-skeleton">
  @for (i of [1, 2, 3, 4]; track $index) {
    <p [tuiSkeleton]="20"></p>
  }
</div>
